import mailStore from 'owa-mail-store/lib/store/Store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
// We validate conversationCache on loadConversationReadingPane
export default function isValidConversationCache(conversationId) {
    var cachedConversation = mailStore.conversations.get(conversationId);
    if (cachedConversation) {
        var conversationSortOrderFromOptions = getUserConfiguration().UserOptions
            .ConversationSortOrderReact;
        // We don't judge if cache is valid or not based on conversationToLoad.loadingState.isLoading,
        // because even if loading in progress, conversationToLoad still could be a valid cache.
        return (cachedConversation.conversationNodeIds.length > 0 &&
            !cachedConversation.loadingState.hasLoadFailed &&
            cachedConversation.conversationSortOrder == conversationSortOrderFromOptions);
    }
    return false;
}
//# sourceMappingURL=isValidConversationCache.js.map